import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import SolarPanel from "./pages/Products/SolarPanel";
import Battery from "./pages/Products/Battery";
import ScrollToTop from "./components/ScrollToTop";
import Monitoring from "./pages/Products/Monitoring";
import Maintenance from "./pages/Products/Maintenance";
import Consulting from "./pages/SentBox/Consulting";
import Contact from "./pages/SentBox/Contact";
import AboutUs from "./pages/AboutUs";
export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/solar-panel" element={<SolarPanel />} />
        <Route path="/battery" element={<Battery />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/aboutus" element={<AboutUs />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
